import React, { Component } from "react";
import { Modal, Tabs, Tab, Button } from "react-bootstrap";
import "./assignmanager.css";
import apis from "../../services/apis";
import apiCommonParams from "../../constants/apiCommonParams";
import { toast } from "react-toastify";
import AppContext from "../../Context/AppContext";

class AssignManager extends Component {
  static contextType = AppContext;
  state = {
    masterProjects: [],

    showManageModal: false,
    selectedProject: null,
    activeTab: "users",
    assigningPM: false,

    // ================= USERS =================
    assignedUsers: [],
    loadingAssignedUsers: false,
    removingUserId: null,

    // User search
    userSearchKeyword: "",
    searchedUsers: [],
    searchingUsers: false,
    selectedUsers: [],

    // ================= GROUPS =================
    masterGroups: [],
    assignedGroups: [],
    loadingAssignedGroups: false,
    assigningGroup: false,

    // Groups (multi-select)
    allGroups: [],
    selectedGroups: [],
    groupPage: 1,
    groupsPerPage: 10,
  };

  /* ================= PROJECT TABLE ================= */

  openManageModal = (project) => {
    this.setState(
      {
        showManageModal: true,
        selectedProject: project,
        activeTab: "users",
        assignedUsers: [],
        assignedGroups: [],
        masterUserId: null,
        masterGroupId: null,
        groupPage: 1,
      },
      () => {
        this.loadAssignedUsersAndGroups();
      }
    );
  };

  closeManageModal = () => {
    this.setState({
      showManageModal: false,
      selectedProject: null,
    });
  };

  /* ================= USERS ================= */

  handleUserSearchChange = (e) => {
    this.setState({ userSearchKeyword: e.target.value });
  };

searchUsers = async () => {
  const { userSearchKeyword, assignedUsers } = this.state;

  if (!userSearchKeyword || userSearchKeyword.length < 2) {
    toast.error("Please enter at least 2 characters");
    return;
  }

  try {
    this.setState({ searchingUsers: true, searchedUsers: [] });

    const token = localStorage.getItem("keycloakToken");
    const { applicationId, siteId } = this.context;
    const users = await apis.searchUsers(applicationId,userSearchKeyword, 20, 0, token);

    const assignedUserIds = assignedUsers.map((u) => u.id);

    const filteredUsers = (users || []).filter(
      (u) => !assignedUserIds.includes(u.userId)
    );

    // ✅ SHOW TOAST ONLY AFTER SEARCH
    if (filteredUsers.length === 0) {
      toast.info("No user found");
    }

    this.setState({ searchedUsers: filteredUsers });
  } catch (err) {
    console.error("Search users error", err);
    toast.error("Failed to search users");
  } finally {
    this.setState({ searchingUsers: false });
  }
};


  toggleUserSelection = (user) => {
    this.setState((prev) => {
      const exists = prev.selectedUsers.some(
        (u) => u.userId === user.userId
      );

      return {
        selectedUsers: exists
          ? prev.selectedUsers.filter((u) => u.userId !== user.userId)
          : [...prev.selectedUsers, user],
      };
    });
  };

  clearUserSearch = () => {
    this.setState({
      userSearchKeyword: "",
      searchedUsers: [],
    });
  };

  assignSelectedUsers = async () => {
    const { selectedUsers, selectedProject, assignedUsers } = this.state;
    if (!selectedUsers.length || !selectedProject) return;

    try {
      this.setState({ assigningPM: true });
      const token = localStorage.getItem("keycloakToken");
      const { applicationId, siteId } = this.context;

      for (const user of selectedUsers) {
        if (assignedUsers.some((u) => u.id === user.userId)) continue;

        const formData = new FormData();
        formData.append("applicationid", applicationId);
        formData.append("siteid", siteId);
        formData.append("userid", user.userId);
        formData.append("roleid", apiCommonParams.roleid);
        formData.append("moduleid", apiCommonParams.moduleid);
        formData.append("treeid", apiCommonParams.treeid);
        formData.append("entityid", selectedProject.value);
        formData.append("entitytype", "project");
        formData.append("swcmTicket", apiCommonParams.swcmTicket);

        await apis.assignProjectManagerRole(formData, token);
      }

      toast.success("Selected users assigned successfully");
      this.setState({ selectedUsers: [] });
      await this.loadAssignedUsersAndGroups();
    } catch (err) {
      console.error(err);
      toast.error("Failed to assign users");
    } finally {
      this.setState({ assigningPM: false });
    }
  };

  removeUser = async (user) => {
    const { selectedProject } = this.state;
    if (!user || !selectedProject) return;

    try {
      this.setState({ removingUserId: user.id });
      const token = localStorage.getItem("keycloakToken");
      const { applicationId, siteId } = this.context;
      const formData = new FormData();
      formData.append("applicationid", applicationId);
      formData.append("siteid", siteId);
      formData.append("userid", user.id);
      formData.append("entityid", selectedProject.value);
      formData.append("entitytype", "project");
      formData.append("swcmTicket", apiCommonParams.swcmTicket);

      const response = await apis.removeProjectManagerRole(formData, token);

      if (response?.code === "SUCCESS") {
        await this.loadAssignedUsersAndGroups();
        toast.success("Project Manager removed successfully!");
      } else {
        toast.error("Something went wrong, please try again later!");
      }
    } catch (err) {
      console.error("Remove PM error", err);
      toast.error("Something went wrong, please try again later!");
    } finally {
      this.setState({ removingUserId: null });
    }
  };

  /* ================= GROUPS ================= */

  toggleGroupSelection = (group) => {
    this.setState((prev) => {
      const exists = prev.selectedGroups.some((g) => g.id === group.id);

      return {
        selectedGroups: exists
          ? prev.selectedGroups.filter((g) => g.id !== group.id)
          : [...prev.selectedGroups, group],
      };
    });
  };

  assignSelectedGroups = async () => {
    const { selectedGroups, selectedProject } = this.state;
    if (!selectedGroups.length || !selectedProject) return;

    try {
      this.setState({ assigningGroup: true });
      const token = localStorage.getItem("keycloakToken");
      const { applicationId, siteId } = this.context;

      for (const group of selectedGroups) {
        const formData = new FormData();
        formData.append("applicationid", applicationId);
        formData.append("siteid", siteId);
        formData.append("groupid", group.id);
        formData.append("roleid", apiCommonParams.roleid);
        formData.append("moduleid", apiCommonParams.moduleid);
        formData.append("treeid", apiCommonParams.treeid);
        formData.append("entityid", selectedProject.value);
        formData.append("entitytype", "project");
        formData.append("swcmTicket", apiCommonParams.swcmTicket);

        await apis.assignProjectManagerGroup(formData, token);
      }

      toast.success("Selected groups assigned successfully");
      this.setState({
        selectedGroups: [],
        groupPage: 1, 
      },
  async () => {
    await this.loadAssignedUsersAndGroups();
  });
      await this.loadAssignedUsersAndGroups();
    } catch (err) {
      console.error(err);
      toast.error("Failed to assign groups");
    } finally {
      this.setState({ assigningGroup: false });
    }
  };

  removeGroup = async (group) => {
    const { selectedProject } = this.state;
    if (!group || !selectedProject) return;

    try {
      this.setState({ removingGroupId: group.id });
      const token = localStorage.getItem("keycloakToken");
      const { applicationId, siteId } = this.context;
      const formData = new FormData();
      formData.append("applicationid", applicationId);
      formData.append("siteid", siteId);
      formData.append("groupid", group.id);
      formData.append("entityid", selectedProject.value);
      formData.append("entitytype", "project");
      formData.append("swcmTicket", apiCommonParams.swcmTicket);

      const response = await apis.removeProjectManagerGroup(formData, token);

      if (response?.code === "SUCCESS") {
        await this.loadAssignedUsersAndGroups();
        toast.success("Group removed successfully!");
      } else {
        toast.error("Something went wrong, please try again later!");
      }
    } catch (err) {
      console.error("Remove group error", err);
      toast.error("Something went wrong, please try again later!");
    } finally {
      this.setState({ removingGroupId: null });
    }
  };

  /* ================= PROJECTS ================= */

  loadProjects = async () => {
    try {
      const token = localStorage.getItem("keycloakToken");
      const { applicationId, siteId } = this.context;
      const isGlobalAdmin = JSON.parse(
        localStorage.getItem("isGlobalAdmin")
      );
      const response = await apis.getProjects(
        applicationId,siteId,
        this.state.userId,
        isGlobalAdmin,
        token
      );

      this.setState({ masterProjects: response || [] });
    } catch (error) {
      console.error("Error loading projects", error);
    }
  };

  /* ================= ASSIGNED USERS & GROUPS ================= */

  loadAssignedUsersAndGroups = async () => {
    try {
      this.setState({
        loadingAssignedUsers: true,
        loadingAssignedGroups: true,
      });

      const token = localStorage.getItem("keycloakToken");
      const { applicationId, siteId } = this.context;
      const projectId = this.state.selectedProject?.value;
      if (!projectId) return;

      const response = await apis.getAssignedUsersAndGroups(applicationId, siteId,projectId, token);
      const parsed = response?.json ? JSON.parse(response.json) : {};

      const userList =
        parsed?.contentLevelUserRoleHBList?.contentLevelUserRoleHBs || [];

      const groupList =
        parsed?.contentLevelUserGroupRoleHBList
          ?.contentLevelUserGroupRoleHBList || [];

      const allGroups =
        parsed?.contentLevelUserGroupHB?.userGroupList || [];

      this.setState({
        assignedUsers: userList.map((x) => ({
          id: x.userTO.userId,
          name: `${x.userTO.firstName} ${x.userTO.lastName}`,
          username: x.userTO.username,
          email: x.userTO.email,
        })),
        assignedGroups: groupList.map((g) => ({
          id: g.userGroupTO.groupId,
          name: g.userGroupTO.groupName,
        })),
        allGroups: allGroups.map((g) => ({
          id: g.groupId,
          name: g.groupName,
        })),
      });
    } catch (err) {
      console.error("Error loading assigned users/groups", err);
    } finally {
      this.setState({
        loadingAssignedUsers: false,
        loadingAssignedGroups: false,
      });
    }
  };

  componentDidMount() {
    this.loadProjects();
  }

  render() {
    const {
      showManageModal,
      activeTab,
      assignedUsers,
      assignedGroups,
      allGroups,
      masterProjects,
      selectedProject,
      loadingAssignedUsers,
      loadingAssignedGroups,
      assigningPM,
      assigningGroup,
    } = this.state;

   const { groupPage, groupsPerPage } = this.state;

    const availableGroups = allGroups.filter(
      (g) => !assignedGroups.some((ag) => ag.id === g.id)
    );

    const totalGroupPages = Math.ceil(
      availableGroups.length / groupsPerPage
    );

    const paginatedGroups = availableGroups.slice(
      (groupPage - 1) * groupsPerPage,
      groupPage * groupsPerPage
    );

    return (
      <div className="projects-page">
        
    <div className="projects-container">

      {/* ===== PAGE HEADER ===== */}
      <div className="projects-header">
        <h2 className="projects-title">Projects</h2>
        <p className="projects-subtitle">
          Select a project to manage project managers at both user and group levels.
        </p>
      </div>

      {/* ===== PROJECT TABLE CARD ===== */}
      <div className="projects-card">
        <table className="projects-table">
          <thead>
            <tr>
              <th>Project Name</th>
              <th className="action-col">Action</th>
            </tr>
          </thead>
          <tbody>
            {masterProjects.length === 0 ? (
              <tr>
                <td colSpan="2" className="no-data">
                  No projects found
                </td>
              </tr>
            ) : (
              masterProjects.map((project) => (
                <tr key={project.value}>
                  <td>{project.label}</td>
                  <td className="action-col">
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => this.openManageModal(project)}
                    >
                      Manage
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </div>

    
   <Modal
  show={showManageModal}
  onHide={this.closeManageModal}
  size="xl"
  centered
  className="assign-manager-modal"
  enforceFocus={false}   // ✅ FIX
  backdrop="static"
>
      <Modal.Header closeButton>
        <Modal.Title>
          Manage Project Managers —{" "}
          <span className="modal-project-name">
            {selectedProject?.label || ""}
          </span>
        </Modal.Title>
      </Modal.Header>

     <Modal.Body className="manage-modal-body">
  <Tabs
    activeKey={activeTab}
    onSelect={(k) => this.setState({ activeTab: k })}
    className="manage-tabs"
  >
    {/* USERS TAB */}
    <Tab eventKey="users" title="Users">
{/* USER SEARCH SECTION */}
<div className="search-section">
  <h5 className="section-title">Search Users</h5>
  <p className="section-subtitle">
    Find users by name or email and assign them as Project Managers.
  </p>

  <input
    type="text"
    className="form-control"
    placeholder="Search user by name or email"
    value={this.state.userSearchKeyword}
    onChange={this.handleUserSearchChange}
  />

  <div className="d-flex gap-2 mt-3">
    <Button
      variant="primary"
      disabled={this.state.searchingUsers}
      onClick={this.searchUsers}
    >
      {this.state.searchingUsers ? "Searching..." : "Search"}
    </Button>

    <Button
      variant="secondary"
      onClick={this.clearUserSearch}
      disabled={
        !this.state.userSearchKeyword &&
        this.state.searchedUsers.length === 0
      }
    >
      Clear
    </Button>
  </div>
</div>

{this.state.searchedUsers.length > 0 && (
  <>
    <h5 className="section-title mt-4">Search Results</h5>

    <div className="table-wrapper">
      <table className="inner-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Username</th>
            <th>Email</th>
            <th className="action-col">Action</th>
          </tr>
        </thead>

        <tbody>
          {this.state.searchedUsers.map((user) => (
           <tr key={user.userId}>
              <td>{user.userId}</td>
              <td>{user.firstName} {user.lastName}</td>
              <td>{user.username}</td>
              <td className="email-cell">{user.email}</td>
              <td className="action-col">
                <input
                  type="checkbox"
                  checked={this.state.selectedUsers.some(u => u.userId === user.userId)}
                  onChange={() => this.toggleUserSelection(user)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Button
  className="mt-3"
  variant="primary"
  disabled={this.state.selectedUsers.length === 0 || assigningPM}
  onClick={this.assignSelectedUsers}
>
  {assigningPM ? "Assigning..." : "Assign Selected"}
</Button>

    </div>
  </>
)}


      <h5 className="section-title">Assigned Project Manager Users</h5>

      <div className="table-wrapper">
        <table className="inner-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Username</th>
              <th>Email</th>
              <th className="action-col">Action</th>
            </tr>
          </thead>
          <tbody>
            {loadingAssignedUsers ? (
              <tr><td colSpan="5" className="no-data">Loading...</td></tr>
            ) : assignedUsers.length === 0 ? (
              <tr><td colSpan="5" className="no-data">No users assigned</td></tr>
            ) : (
              assignedUsers.map((user) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.name}</td>
                  <td>{user.username}</td>
                  <td className="email-cell">{user.email}</td>
                  <td className="action-col">
                    <Button
                      variant="danger"
                      size="sm"
                      disabled={this.state.removingUserId === user.id}
                      onClick={() => this.removeUser(user)}
                    >
                      {this.state.removingUserId === user.id ? "Removing..." : "Remove"}
                    </Button>

                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </Tab>

    {/* GROUPS TAB */}
   <Tab eventKey="groups" title="Groups">

<div className="search-section">
  <h5 className="section-title">Available Groups</h5>
  <p className="section-subtitle">
    Select groups to assign as Project Managers for this project.
  </p>

  <div className="table-wrapper">
    <table className="inner-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Group Name</th>
          <th className="action-col">Select</th>
        </tr>
      </thead>
      <tbody>
        {availableGroups.length === 0 ? (
          <tr>
            <td colSpan="3" className="no-data">No groups available</td>
          </tr>
        ) : (
          paginatedGroups.map(group => (
            <tr key={group.id}>
              <td>{group.id}</td>
              <td>{group.name}</td>
              <td className="action-col">
                <input
                  type="checkbox"
                  checked={this.state.selectedGroups.some(g => g.id === group.id)}
                  onChange={() => this.toggleGroupSelection(group)}
                />
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>

    {totalGroupPages > 1 && (
      <div className="d-flex justify-content-center mt-3">
        <nav>
          <ul className="pagination pagination-sm mb-0">
            <li className={`page-item ${groupPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => this.setState({ groupPage: groupPage - 1 })}
                disabled={groupPage === 1}
              >
                Previous
              </button>
            </li>

            <li className="page-item disabled">
              <span className="page-link text-dark">
                Page {groupPage} of {totalGroupPages}
              </span>
            </li>

            <li className={`page-item ${groupPage === totalGroupPages ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => this.setState({ groupPage: groupPage + 1 })}
                disabled={groupPage === totalGroupPages}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    )}

    <Button
      className="mt-3"
      variant="primary"
      disabled={this.state.selectedGroups.length === 0 || assigningGroup}
      onClick={this.assignSelectedGroups}
    >
      {assigningGroup ? "Assigning..." : "Assign Selected"}
    </Button>
  </div>
</div>


  <h5 className="section-title mt-4">Assigned Project Manager Groups</h5>

  <div className="table-wrapper">
    <table className="inner-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Group Name</th>
          <th className="action-col">Action</th>
        </tr>
      </thead>
      <tbody>
        {loadingAssignedGroups ? (
          <tr><td colSpan="3" className="no-data">Loading...</td></tr>
        ) : assignedGroups.length === 0 ? (
          <tr><td colSpan="3" className="no-data">No groups assigned</td></tr>
        ) : (
          assignedGroups.map(group => (
            <tr key={group.id}>
              <td>{group.id}</td>
              <td>{group.name}</td>
              <td className="action-col">
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => this.removeGroup(group)}
                >
                  Remove
                </Button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>

</Tab>

  </Tabs>
</Modal.Body>


      <Modal.Footer>
        <Button variant="secondary" onClick={this.closeManageModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  </div>
);


  }
}

export default AssignManager;
